import {
  ApiQuery,
  ApiRequestConfig,
  ApiResponse,
  ApiService,
  EncodeType,
  HttpClient,
} from "@/domain/clients";

export class ApiServiceImpl implements ApiService {
  constructor(private httpClient: HttpClient) {}

  static ContentTypes: Record<EncodeType, string> = {
    formData: "multipart/form-data",
    urlEncoded: "application/x-www-form-urlencoded",
    json: "application/json",
  };

  private handleHeaders = (config?: ApiRequestConfig) => {
    return {
      Accept: "application/json",
      "Content-Type": ApiServiceImpl.ContentTypes[config?.encodeType || "json"],
      ...config?.headers,
    };
  };

  async get<T>(
    url: string,
    query?: ApiQuery,
    config?: ApiRequestConfig,
  ): Promise<ApiResponse<T>> {
    return this.httpClient.request<ApiResponse<T>>({
      url,
      method: "get",
      params: query,
      headers: this.handleHeaders(config),
    });
  }

  async post<T, D>(
    url: string,
    data: D,
    config?: ApiRequestConfig,
  ): Promise<ApiResponse<T>> {
    return this.httpClient.request<ApiResponse<T>>({
      url,
      method: "post",
      body: data,
      headers: this.handleHeaders(config),
    });
  }

  async put<T, D>(
    url: string,
    data: D,
    config?: ApiRequestConfig,
  ): Promise<ApiResponse<T>> {
    return this.httpClient.request<ApiResponse<T>>({
      url,
      method: "put",
      body: data,
      headers: this.handleHeaders(config),
    });
  }

  async delete<T>(
    url: string,
    data?: any,
    config?: ApiRequestConfig,
  ): Promise<ApiResponse<T>> {
    return this.httpClient.request<ApiResponse<T>>({
      url,
      method: "delete",
      body: data,
      headers: this.handleHeaders(config),
    });
  }
}
